import { copyTextToClipboard } from '../utilities/helpers';

const copyToClipboard = () => {
  copyTextToClipboard();
};

export default copyToClipboard;
